var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import history from 'helpers/History';
import { CatalogViewType } from '../../UI/Store';
import NoData from '../../../components/NoData';
import { View, Text } from '../../../elements';
import { SearchInput } from '../../../components';
import theme, { mediaQueries } from '../../../Theme';
import IconosApp, { Icono } from '../../../elements/IconosApp';
import { loading } from '../../../elements/Loading';
import cxs from 'cxs/component';
import FuzzySearch from '../../../helpers/FuzzySearch';
let CollaboratorStretchesList = class CollaboratorStretchesList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            searchTerm: ''
        };
        this.filtered = (searchTerm) => {
            let stretches = this.props.store.collaboratorStretchesStore.services;
            // console.log('StretchesList - operationLine: ', operationLine!.packets)
            if (searchTerm) {
                return FuzzySearch.Stretches(searchTerm, stretches);
            }
            return stretches;
        };
        this.handleSelectCollaboratorStretch = (collaboratorStretch) => {
            history.push(`/detail/cs/${collaboratorStretch.id}/${collaboratorStretch.operator_id}`);
        };
    }
    componentDidMount() {
        this.props.store.UI.setViewType(CatalogViewType.Row);
        // this.props.store.UI.setStretchSelected('')
    }
    render() {
        const { searchTerm } = this.state;
        const collaboratorStretches = this.filtered(searchTerm);
        const viewType = this.props.store.UI.catalogViewType;
        const columns = viewType === CatalogViewType.Cell ? 2 : undefined;
        const { loaded } = this.props.store.collaboratorStretchesStore;
        if (collaboratorStretches.length === 0 && loaded) {
            return (React.createElement(NoData, null));
        }
        return (React.createElement(Wrapper, { flex: true, row: true },
            React.createElement("div", { style: {
                    width: '100%'
                } },
                React.createElement(SearchInput, { onChange: (value) => {
                        this.setState({ searchTerm: value });
                    } })), collaboratorStretches === null || collaboratorStretches === void 0 ? void 0 :
            collaboratorStretches.map(collaboratorStretch => React.createElement(WrapperItem, { flex: true, center: true, key: collaboratorStretch.name + collaboratorStretch.operatorName, onClick: () => this.handleSelectCollaboratorStretch(collaboratorStretch) },
                !collaboratorStretch.image && (React.createElement(IconosApp, { style: {
                        fontSize: '50px',
                    }, name: Icono[collaboratorStretch.icon] })),
                collaboratorStretch.image && (React.createElement("img", { src: collaboratorStretch.image, alt: `imagen ${collaboratorStretch.name}`, style: {
                        height: '50px',
                    } })),
                React.createElement(WrapperText, { center: true }, collaboratorStretch.name)))));
    }
};
CollaboratorStretchesList = __decorate([
    inject('store'),
    observer,
    loading(props => {
        return [
            props.store.collaboratorStretchesStore.read(),
        ];
    })
], CollaboratorStretchesList);
export default CollaboratorStretchesList;
const Wrapper = cxs(View)({
    position: 'relative',
    // height: '100%',
    // height: `${theme.common.devices.desktopHeight}px`,
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
});
const WrapperItem = cxs(View)({
    justifyContent: 'center',
    alignItems: 'center',
    padding: '30px',
    margin: '10px',
    minWidth: '200px',
    maxWidth: '300px',
    height: '200px',
    border: `1px solid ${theme.color.secondary}`,
    borderRadius: '10px',
    ':hover': {
        color: theme.color.primary,
    },
    [mediaQueries.mobile]: {
        minWidth: '40%',
        maxWidth: '50%'
    }
});
const WrapperText = cxs(Text)({
    flex: 1,
    fontSize: '12px',
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/container/CollaboratorStretchesList.tsx
// module id = 540
// module chunks = 0